import React, { Component } from 'react'

import GoogleMapReact from 'google-map-react'
import Point from '../utilities/point'

import { stile1, stile2, stile3, stile4, stile5, stile6 } from '../mappa/stile'

class Mappa extends Component {

    render() {

        const { user, sito } = this.props

        let stileDef = stile1
        let altz = '450px'

        switch (sito.mappa) {
            case 'stile2':
                stileDef = stile2
                break
            case 'stile3':
                stileDef = stile3
                break
            case 'stile4':
                stileDef = stile4
                break
            case 'stile5':
                stileDef = stile5
                break
            case 'stile6':
                stileDef = stile6
                break
            default:
                stileDef = stile1

        }

        switch (sito.altezzaMappa) {
            case 'full':
                altz = '100vh'
                break
            case 'bassa':
                altz = '300px'
                break
            default:
                altz = '450px'

        }

        return (
            <div style={{ height: altz }}>

                <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyBci-Kct7x2uLWWDWqBV0ciOcfL6TPCSsM' }}
                    defaultCenter={{ lat: user.lat1, lng: user.lng1 }}
                    defaultZoom={11}
                    yesIWantToUseGoogleMapApiInternals
                    options={{ styles: stileDef }}
                >

                    <Point
                        lat={user.lat1}
                        lng={user.lng1}
                        nome={user.name}
                        provincia={user.provincia1}
                        citta={user.citta1}
                        via={user.via1}
                        immagine={user.foto}
                        colore={sito.coloreAccento || '#03a9f4'}
                    />

                </GoogleMapReact>

            </div>
        )
    }
}

export default Mappa


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/mappa/index.js